import { Box, Heading } from '@hover/blueprint';
import { navigate } from 'gatsby';
import React from 'react';
import { SCHEDULE_A_MEETING_LINK } from '../../../constants';
import ArrowButton from '../../ui/ArrowButton';

const ChooseThePlanFooter: React.FC = () => {
  const navigateTo = () => navigate(SCHEDULE_A_MEETING_LINK);

  return (
    <Box
      flexDir="column"
      alignItems="center"
      mt={{ base: 700, tablet: '80px' }}
      mb={1000}
      px={200}
    >
      <Heading
        textAlign="center"
        size={{ base: 300, tablet: 500 }}
        marginBottom={{ base: 500, tablet: 700 }}
        isDisplay
      >
        Interested in learning more about our products?
      </Heading>
      <ArrowButton colorScheme="primary" onClick={navigateTo}>
        Schedule a meeting
      </ArrowButton>
    </Box>
  );
};

export default ChooseThePlanFooter;
